function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { colors } from '../../../abstracts';
import { Text } from '../../../components/Text';
import { createTransition, dontForwardProps } from '../../../util';
const StyledDescription = styled(Text).withConfig(dontForwardProps()).withConfig({
  displayName: "StyledDescription",
  componentId: "asurion-ui-react__sc-1hjs28a-0"
})(["&&{line-height:1.35;", ";", "}"], ({
  disabled
}) => disabled && `cursor: not-allowed; color: ${colors.disabledText}`, () => createTransition({
  properties: ['color']
}));
export const CheckboxDescription = props => /*#__PURE__*/React.createElement(StyledDescription, _extends({
  size: 2
}, props));